<template>
	<div>
		<!-- ------------------------------信箱修改開始------------------------------ -->
        <div class="modal fade cm-modal" id="changeEmailModal" tabindex="-1" role="dialog"
            aria-labelledby="registerModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered cm-modal-changeEmail" role="document">
                <div class="modal-content">
                    <div class="modal-header p-0 text-center cm-modal-changeEmailModal-header">
                        <h4 class='col-12 modal-title text-center text-white'>
                            {{$t('modal.ChangeEmail.Title')}}
                            <button type="button" class="close cm-changeEmail-close" data-dismiss="modal"
                                aria-label="Close">
                                <span aria-hidden="true">
                                    <img src="@/assets/images/login-close.png">
                                </span>
                            </button>
                        </h4>
                    </div>
                    <div class="modal-body pb-5 cm-modal-changeEmailModal-body">
                        <div class="col-12 px-sm-3 p-0 pt-5 row no-gutters">
                            <div class="col-12 px-sm-3 px-0 form-group row">
                                <label for="" class="col-sm-5 col-form-label text-sm-right">{{$t('modal.ChangeEmail.Input.NewEmail')}}</label>
                                <div class="col-sm-7">
                                    <input type="text" class="form-control" v-model="inputNewEmail" v-on:blur="newEmailInputMonitor">
                                    <span class="text-danger" v-if="newEmailPromptString !== ''">{{newEmailPromptString}}</span>
                                </div>
                            </div>
                            <div class="col-12 px-sm-3 px-0 form-group row">
                                <label for="" class="col-sm-5 col-form-label text-sm-right">{{$t('modal.ChangeEmail.Input.ConfirmNewEmail')}}</label>
                                <div class="col-sm-7">
                                    <input type="text" class="form-control" v-model="inputConfirmEmail" v-on:blur="confirmEmailInputMonitor">
                                    <span class="text-danger" v-if="confirmEmailPromptString !== ''">{{confirmEmailPromptString}}</span> 
                                </div>
                            </div>
                            <div class="col-12 mt-sm-5 mt-0 mb-4 row no-gutters">
                                <!-- 確認按鈕 -->
                                <div v-if="domControl.isWaitingChangeEmail==true" class="col-sm-6 col-12 px-3 my-1 text-center">
                                    <div class="spinner-border text-warning text-center my-2" role="status"></div>
                                </div>
                                <div v-else class="col-sm-6 col-12 px-3 my-1 d-flex justify-content-center justify-content-sm-end">
                                    <button class="btn w-75" @click="submitBtn">{{$t('modal.ChangeEmail.Button.Confirm')}}</button>
                                </div>

                                <!-- 取消按鈕 -->
                                <div class="col-sm-6 col-12 px-3 my-1 d-flex justify-content-center justify-content-sm-start" data-dismiss="modal" aria-label="Close">
                                    <button class="btn w-75">{{$t('modal.ChangeEmail.Button.Cancel')}}</button>
                                </div>
                            </div>
                        </div>
                        <img src="@/assets/images/cmi_logo_black.png" class="cm-changeEmailModal-logo-img">
                    </div>
                </div>
            </div>
        </div>
        <!-- ------------------------------信箱修改結束------------------------------ -->
	</div>
</template>

<script>

import $ from "jquery"
import axios from "axios"
import router from '@/router'
import eventBus from "@/assets/js/event/EventBus.js"
import RecaptchaUtil from "@/assets/js/util/RecaptchaUtil.js"
import ValidatorUtil from '@/assets/js/util/ValidatorUtil.js'

export default {
    data() {
        return {
            changeEmailKey: "",
            inputNewEmail: "",
            newEmailPromptString: "",
            inputConfirmEmail: "",
            confirmEmailPromptString: "",
            domControl: {
                isWaitingChangeEmail: false
            }
        }
    },
    mounted() {
        const self = this;
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_MEMBER_EMAIL, function(i18n, changeEmailKey) {
            self.changeEmailKey = changeEmailKey;
            self.eventBusOpenEmailModal(i18n);
        });

        $("#changeEmailModal").on('hidden.bs.modal', function () {
            self.clearData();
        })
    },
    methods: {
        clearData() {
            this.inputNewEmail = "";
            this.newEmailPromptString = "";
            this.inputConfirmEmail = "";
            this.confirmEmailPromptString = "";
        },
        async eventBusOpenEmailModal(i18n = this.$i18n) {
            const result = await this.checkSetEmailKey();
            if(result) {
                $("#changeEmailModal").modal("show");
            }
            else {
                alert(i18n.t('modal.ChangeEmail.Alert.Error.ChangeEmailKey'));
            }
        },
        async checkSetEmailKey() {
            let result = false;
            if(this.changeEmailKey!="" && this.changeEmailKey!=undefined && this.changeEmailKey!=null) {
                const self = this;
                const response = await axios({
                    method: "get",
                    timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                    url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/checkSetEmailKeyAction.shtml?key=" + self.changeEmailKey + "&_=" + new Date().getTime()
                })
                .catch(function() {
                    alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
                })

                // 判斷Ajax結果
                if(response!=null && response!=undefined) {
                    if(response.data.result=="success") {
                        result = true;
                    }
                    else { // key判斷結果不為success時
                        this.changeEmailKey = ""; // key失效，清空
                    }
                }
            }
            return result;
        },
        newEmailInputMonitor() {
            // 驗證email字串不為空，且符合格式
            this.newEmailPromptString = ValidatorUtil.validEmail(this.inputNewEmail, {
                'req': this.$i18n.t('modal.ChangeEmail.Validate.NewEmail.req'),
                'format': this.$i18n.t('modal.ChangeEmail.Validate.NewEmail.format'),
            })
        },
        confirmEmailInputMonitor() {
            if(this.inputNewEmail != this.inputConfirmEmail) {
                this.confirmEmailPromptString = this.$i18n.t('modal.ChangeEmail.Validate.ConfirmPassword.notEqual');
            }
            else {
                this.confirmEmailPromptString = "";
            }
        },
        async submitBtn() {
            this.newEmailInputMonitor();
            this.confirmEmailInputMonitor();
            if(this.newEmailPromptString=="" && this.confirmEmailPromptString=="") {
                RecaptchaUtil.startGoogleRecaptchaVerify(process.env.VUE_APP_AUTH_RECAPTCHA_CHANGE_EMAIL, this.ajaxChangeEmailAction);
            }
        },
        async ajaxChangeEmailAction(gRecaptchaResponse) {
            this.domControl.isWaitingChangeEmail = true

            // POST參數
            let bodyFormData = new FormData();
            bodyFormData.append("key", this.changeEmailKey);
            bodyFormData.append("email", this.inputNewEmail);
            bodyFormData.append("mydomain", "all9fun.com");
            bodyFormData.append("g-recaptcha-response", gRecaptchaResponse);

            // Ajax
            const self = this;
            const response = await axios({
                method: "post",
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/changeEmailAction.shtml",
                data: bodyFormData
            })
            .catch(function() {
                alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
            })

            this.domControl.isWaitingChangeEmail = false
            
            // 判斷Ajax結果
            if(response!=null && response!=undefined) {
                if(response.data.result == "success") {
                    this.changeEmailKey = "";
                    alert(this.$i18n.t('modal.ChangeEmail.Backend.Response.changeSuccess'));
                    if(router.currentRoute.name != process.env.VUE_APP_ROUTER_HOME) {
                        location.href = "/";
                    }
                    else {
                        $("#changePasswordModal").modal("hide");
                    }
                }
                else if(response.data.result == "emailFomat") {
                    alert(this.$i18n.t('modal.ChangeEmail.Backend.Response.emailFomat'));
                }
                else if(response.data.result == "emailEmpty") {
                    alert(this.$i18n.t('modal.ChangeEmail.Backend.Response.emailEmpty'));
                }
                else if(response.data.result == "emailExist") {
                    alert(this.$i18n.t('modal.ChangeEmail.Validate.NewEmail.exist'));
                }
                else {
                    alert(this.$i18n.t('modal.ChangeEmail.Backend.Response.changeFailed'));
                }
            }
        }
    }
}
</script>